import {isPlatformBrowser, isPlatformServer} from '@angular/common';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {makeStateKey, TransferState} from '@angular/platform-browser';
import {Observable} from 'rxjs/Observable';
import {of} from 'rxjs/observable/of';
import {tap} from 'rxjs/operators';
import {RequestKeyExtractorService} from './request-key-extractor.service';

const /** @type {?} */ STATE_KEY_PREFIX = 'http_requests:';
export class TransferHttpResponseInterceptor implements HttpInterceptor {
/**
 * @param {?} transferState
 * @param {?} requestKeyExtractor
 * @param {?} platformId
 */
constructor(private transferState: TransferState,
private requestKeyExtractor: RequestKeyExtractorService,
private platformId: string) {
  }
/**
 * @param {?} req
 * @param {?} next
 * @return {?}
 */
intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Nothing to do with non-GET requests
    if (req.method.toUpperCase() !== 'GET') {
      return next.handle(req);
    }

    const /** @type {?} */ key = makeStateKey<HttpResponse<object>>(STATE_KEY_PREFIX + this.requestKeyExtractor.getKey(req));
    // console.log(`key for ${req.url} => ${key}`);
    if (isPlatformBrowser(this.platformId)) {
      // Try reusing transferred response from server
      const /** @type {?} */ cachedResponse = this.transferState.get(key, null);
      if (cachedResponse) {
        this.transferState.remove(key); // using transferred state should be used for the very first time
        return of(new HttpResponse({
          body: cachedResponse.body,
          status: 200,
          statusText: 'OK (from server)',

        }));
      }
      return next.handle(req);
    }

    if (isPlatformServer(this.platformId)) {
      // Try saving response to be transferred to browser
      return next.handle(req).pipe(tap(event => {
        if (event instanceof HttpResponse && event.status == 200) {
          // Update the cache.
          // for only body is preserved as it is. It would be nice to transfer whole response, but http response is not
          // a POJO and it needs custom serialization/deserialization.
          const /** @type {?} */ response = {
            body: event.body
          };
          // console.log(`saving response for ${key}`, response);
          this.transferState.set(key, response);
        }
      }));
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TransferState, },
{type: RequestKeyExtractorService, },
{type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID, ] }, ]},
];
}

function TransferHttpResponseInterceptor_tsickle_Closure_declarations() {
/** @type {?} */
TransferHttpResponseInterceptor.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TransferHttpResponseInterceptor.ctorParameters;
/** @type {?} */
TransferHttpResponseInterceptor.prototype.transferState;
/** @type {?} */
TransferHttpResponseInterceptor.prototype.requestKeyExtractor;
/** @type {?} */
TransferHttpResponseInterceptor.prototype.platformId;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
